import { HeroPillCategoryEnum_en } from "@/shared/data/hero-pills.data";
import { Typography } from "@graphy/ui";
import { useRouter } from "next/router";
import { useState } from "react";
import HeroPill from "../atoms/HeroPill";
import { SectionHeadingType } from "../atoms/SectionHeading";
import ToggleButton from "../organisms/ToggleButton";
import PricingCard, { PlansType } from "./PricingCard";
import PricingHeroHeading from "./PricingHeroHeading";

export enum BillingCycleType {
  Month = "month",
  Year = "year",
}

export type PricingComparisonSectionPropsType = {
  heroPill: {
    category: HeroPillCategoryEnum_en.Pricing | HeroPillCategoryEnum_en.Pricing;
  };
  title: SectionHeadingType;
  description: string;
  subDescription?: string;
  billingCycles: { value: BillingCycleType; label: string }[];
  DiscountText: string;
  plans: PlansType[];
};

const PricingComparisonSection = ({
  heroPill,
  title,
  description,
  subDescription = "No fine print. No hidden limits. Just choose your plan and start.",
  billingCycles,
  DiscountText,
  plans,
}: PricingComparisonSectionPropsType) => {
  const [billlingCycle, setBillingCycle] = useState(billingCycles && billingCycles[0]?.value);
  const router = useRouter();

  return (
    <div className="container">
      <div className="flex  flex-col items-center gap-8">
        <div className="relative flex  flex-col items-center gap-3">
          {/* <BgTwoStars className="pointer-events-none absolute left-0 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 sm:block" /> */}
          {heroPill?.category && <HeroPill category={heroPill.category}  className="bg-white font-bold" textColor="#2A2861" />} {/* Added bg color */}
          <div className="relative pr-4 text-center sm:pr-3">
            <PricingHeroHeading heading={title} isComparePlans={true} />
            {/* <BgSpringArrow className="absolute left-full top-1/2 -translate-y-1/3 scale-75 sm:translate-y-0 sm:scale-100" /> */}
          </div>
          <Typography
            fontSize="text-body"
            colorClass="text-grey-3"
            fontWeight="font-normal"
            className="max-w-md"
            align="text-center"
          >
            {description}
          </Typography>
          {subDescription && (
            <Typography
              fontSize="text-body"
              colorClass="text-grey-3"
              fontWeight="font-normal"
              className="max-w-md mt-1"
              align="text-center"
            >
              {subDescription}
            </Typography>
          )}
        </div>
        <div className="w-full">
          {billingCycles.length > 1 && (
            <div className={"relative flex flex-row justify-center md:h-[60px]"}>
              <ToggleButton
                options={billingCycles.map(opt =>
                  opt.value === BillingCycleType.Year
                    ? {
                        ...opt,
                        label: (
                          <div className="flex items-center">
                            <span>{opt.label}</span>
                            <span className="ml-2 rounded-2xl bg-successMid px-2 py-1 text-xs font-semibold text-white">
                              {DiscountText}
                            </span>
                          </div>
                        ),
                      }
                    : opt
                )}
                className="h-fit items-center justify-center"
                selectedColor="white"
                handleToggle={(value: BillingCycleType) => {
                  setBillingCycle(value);
                }}
                defaultSelectedOption={billingCycles[0]}
                selectedTextColor="black"
                textColor="black"
              />
            </div>
          )}
        </div>
        {/* Pricing Table */}
        {router.pathname === "/pricing" ? (
          <div className="flex w-full flex-col gap-4 overflow-hidden md:flex-row md:gap-0 md:rounded-xl items-stretch">
            {plans.map((plan: PlansType, idx: number) => {
              let cardBg = "bg-white border-[#E5E5E5]";
              if (idx === 1) cardBg = "bg-[#F1F0FF] border-[#E5E5E5]";
              let radius = "";
              if (idx === 0) radius = "rounded-[16px] ";
              else if (idx === plans.length - 1) radius = "rounded-[16px] ";
              else radius = "rounded-[16px] ";
              const borderFix = idx !== plans.length - 1 ? "md:border-r-1" : "";
              const cardClass = `${cardBg} ${radius} h-full flex flex-col border ${borderFix}`;
              const wrapperClass = idx !== plans.length - 1 ? "md:mr-8" : "";
              return (
                <div className={`w-full ${wrapperClass} flex-1 h-[440px]`} key={plan.planName}>
                  <div className={cardClass}>
                    <PricingCard
                      {...plan}
                      billingCycle={billlingCycle}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex w-full flex-col gap-4 overflow-hidden md:flex-row md:gap-0 md:rounded-xl items-stretch">
            {plans.map((plan: PlansType, idx: number) => (
              <div className={`w-full flex-1 h-[440px]`} key={plan.planName}>
                <div className="bg-white rounded-[16px] h-full flex flex-col border border-grey-2">
                  <PricingCard
                    {...plan}
                    billingCycle={billlingCycle}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PricingComparisonSection;
